// Importing Landmark Images
import axios from 'axios';

import adoAwaye from '../assets/landmarks/ado_awaye.jpg';
import agbeleRock from '../assets/landmarks/agbele_rock.jpg';
import barBeach from '../assets/landmarks/bar_beach.jpg';
import ebomiLake from '../assets/landmarks/ebomi_lake.jpg';
import ikogosiWarmSpring from '../assets/landmarks/ikogosi_warm_spring.jpg';
import iyaleSuspended from '../assets/landmarks/iyale_suspended.jpg';
import okeIdanre from '../assets/landmarks/oke_idanre.jpg';
import okutaGbokuta from '../assets/landmarks/okuta_gbokuta_lori.jpg';
import olumoRock from '../assets/landmarks/olumo_rock.jpg';
import osunRiver from '../assets/landmarks/osun_river.jpg';
import osuuruSpring from '../assets/landmarks/osuuru_water_spring.jpg';
import owuWaterfall from '../assets/landmarks/owu_waterfall.jpg';
import sobiHill from '../assets/landmarks/sobihill.jpg';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/+$/, '');

const normalizeMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (typeof window === 'undefined') return url;
  
  // If it's a base64 string, return as is
  if (url.startsWith('data:')) return url;

  // If it's a relative path, prepend API base URL
  let finalUrl = url;
  if (url.startsWith('/uploads/') || url.startsWith('uploads/')) {
    const relativePath = url.startsWith('/') ? url : `/${url}`;
    finalUrl = `${API_BASE_URL.replace('/api', '')}${relativePath}`;
  }

  try {
    const current = window.location;
    const parsed = new URL(finalUrl, current.origin);
    
    // Only force protocol for http/https URLs, not for data: or others
    if (parsed.protocol.startsWith('http') && parsed.protocol !== current.protocol) {
      parsed.protocol = current.protocol;
      return parsed.toString();
    }
    return parsed.toString();
  } catch (e) {
    // Fallback for non-URL strings or failed parsing
    return finalUrl;
  }
};

export const DEFAULT_LANDMARKS = [
    {
        id: 1,
        title: "OWU WATERFALL",
        location: "OLD OYO EMPIRE",
        desc: "The highest waterfall in West Africa, cascading down 120 meters into a pool of ice-cold water.",
        img: owuWaterfall
    },
    {
        id: 2,
        title: "SOBI HILL",
        location: "OLD OYO EMPIRE",
        desc: "A scenic hill offering hiking trails and panoramic views, a favorite spot for nature lovers and adventurers.",
        img: sobiHill
    },
    {
        id: 3,
        title: "OLUMO ROCK",
        location: "ABEOKUTA",
        desc: "The historic fortress of Abeokuta, providing refuge during inter-tribal wars and offering panoramic views of the city.",
        img: olumoRock
    },
    {
        id: 4,
        title: "OSUURU WATER SPRING ABEOKUTA",
        location: "ABEOKUTA",
        desc: "A refreshing natural spring in Abeokuta, known for its purity and continuous flow through the seasons.",
        img: osuuruSpring
    },
    {
        id: 5,
        title: "OKE IDANRE",
        location: "IDANRE",
        desc: "The magnificent Idanre Hills, a UNESCO World Heritage candidate, featuring ancient settlements and diverse ecosystems.",
        img: okeIdanre
    },
    {
        id: 6,
        title: "EBOMI LAKE",
        location: "IDANRE",
        desc: "A pristine body of water located in the heart of our land, known for its mysterious depth and cultural importance.",
        img: ebomiLake
    },
    {
        id: 7,
        title: "ADO AWAYE",
        location: "IBADAN",
        desc: "Home to one of the only two suspended lakes in the world, the Iyake Lake, offering breathtaking views and spiritual significance.",
        img: adoAwaye
    },
    {
        id: 8,
        title: "OKUTA GBOKUTA LORI",
        location: "OROLE",
        desc: "The 'Stone upon Stone' formation, a marvelous balancing rock structure that has stood the test of time.",
        img: okutaGbokuta
    },
    {
        id: 9,
        title: "IKOGOSI WARM SPRING",
        location: "EKITI",
        desc: "A geological wonder where warm and cold springs meet, flowing side by side without mixing.",
        img: ikogosiWarmSpring
    },
    {
        id: 10,
        title: "BAR BEACH",
        location: "EKO",
        desc: "A historic coastal stretch that has witnessed the evolution of our great nation, offering serenity and ocean views.",
        img: barBeach
    },
    {
        id: 11,
        title: "OSUN RIVER",
        location: "OSUN",
        desc: "The sacred river dedicated to the river goddess Osun, flowing through the UNESCO World Heritage Sacred Grove.",
        img: osunRiver
    },
    {
        id: 12,
        title: "AGBELE ROCK, IGBETI",
        location: "STATE OF IBADAN",
        desc: "A natural masterpiece in the Yoruba land, standing as a symbol of resilience and natural beauty.",
        img: agbeleRock
    },
    {
        id: 13,
        title: "IYALE SUSPENDED LAKE ON THE OKE ADO MOUNTAIN IN ADO AWAYE,",
        location: "STATE OF IBADAN",
        desc: "A rare geographical phenomenon, this suspended lake sits atop the mountains, defying gravity and logic.",
        img: iyaleSuspended
    }
];

export const getLandmarks = async () => {
    try {
        const res = await axios.get(`${API_BASE_URL}/landmarks`);
        const items = Array.isArray(res.data) ? res.data : [];
        if (!items.length) {
            return DEFAULT_LANDMARKS;
        }
        return items.map(item => ({
            ...item,
            img: normalizeMediaUrl(item.img)
        }));
    } catch (err) {
        console.error("Error loading landmarks:", err);
        return DEFAULT_LANDMARKS;
    }
};

export const saveLandmark = async (landmark) => {
    const payload = {
        title: landmark.title,
        location: landmark.location,
        desc: landmark.desc,
        img: landmark.img
    };
    try {
        if (landmark.id) {
            await axios.put(`${API_BASE_URL}/landmarks/${landmark.id}`, payload);
        } else {
            await axios.post(`${API_BASE_URL}/landmarks`, payload);
        }
        // Always fetch the latest list from the server to ensure consistency
        const all = await getLandmarks();
        return all;
    } catch (err) {
        console.error("Error saving landmark:", err);
        throw err; // Propagate error to caller
    }
};

export const deleteLandmark = async (id) => {
    await axios.delete(`${API_BASE_URL}/landmarks/${id}`);
    const all = await getLandmarks();
    return all;
};
